"use client";

import { useTranslations } from "next-intl";
import { useConsumerLocale } from "@/app/i18n/ConsumerIntlProvider";
import { TermsPageView } from "@/components/terms/TermsPageView";
import { AnalyticsConsentSettings } from "@/components/analytics/AnalyticsConsentBanner";
import type { ParsedTerms } from "@/content/parseConsumerTerms";

/**
 * Renders privacy policy chrome around build-time Spanish markdown.
 */
export function PrivacyPageClient({ data }: { data: ParsedTerms }) {
  const t = useTranslations("privacy");
  const { locale } = useConsumerLocale();
  return (
    <>
      <TermsPageView
        title={t("title")}
        subtitle={t("subtitle")}
        backLabel={t("backToEvents")}
        languageNote={locale === "en" ? t("languageNote") : null}
        introParagraphs={data.introParagraphs}
        sections={data.sections}
      />
      <AnalyticsConsentSettings />
    </>
  );
}
